export default "__VITE_ASSET__BK1l4o8H__"